export const BESTSELLER_TAG_CLASS_NAMES = {
  sales: 'bg-gradient-to-r from-[#ffebcd] to-[#ffe3bb] text-[#b06814]',
  trend: 'bg-[#e4ebfe] text-[#44427a]',
} as const;

export const BESTSELLER_RANKING_HOVER_MEDIA_CLASS_NAME = 'bg-white';

export const BESTSELLER_RANKING_CARD_LAYOUT_CLASS_NAMES = {
  large:
    'grid overflow-hidden rounded-[6px] bg-white md:h-[266px] md:grid-cols-[33.45%_33.45%_33.1%] xl:h-[340px] xl:rounded-[8px] 2xl:h-[520px]',
  compact:
    'grid h-[184px] overflow-hidden rounded-[5px] bg-white sm:grid-cols-[61%_39%] xl:h-[234px] xl:rounded-[8px] 2xl:h-[364px]',
} as const;

export const BESTSELLER_MOBILE_RANKING_CARD_LAYOUT_CLASS_NAMES = {
  top: 'relative grid h-[187px] grid-cols-2 grid-rows-[100px_87px] overflow-hidden rounded-[4px] bg-white',
  compact: 'grid h-[207px] grid-rows-[129px_78px] overflow-hidden rounded-[4px] bg-white',
} as const;

export const BESTSELLER_RANKING_TAB_CLASS_NAME =
  'relative flex h-[60px] w-full items-center justify-center gap-[4px] border-x-0 border-t-0 border-solid bg-[#f7f7f7] px-[8px] font-bb text-[14px] leading-[20px] text-[#282828] md:h-full md:cursor-pointer md:gap-[6px] md:text-[16px] md:leading-[19px] xl:gap-[8px] xl:text-[20px] xl:leading-[24px] 2xl:gap-[12px] 2xl:text-[32px] 2xl:leading-[38px]';

export const BESTSELLER_VIBE_ARROW_CLASS_NAME =
  'absolute top-[40%] z-[2] hidden -translate-y-1/2 cursor-pointer items-center justify-center rounded-none border border-solid border-[#f7f7f7] bg-[#f7f7f7] p-0 text-[#666666] transition-colors hover:bg-[#f7f7f7] hover:text-[#666666] md:flex md:h-[28px] md:w-[16px] xl:h-[36px] xl:w-[21px] 2xl:h-[56px] 2xl:w-[33px]';

export const BESTSELLER_VIBE_ARROW_ICON_CLASS_NAME =
  'md:h-[12px] md:w-[12px] xl:h-[16px] xl:w-[16px] 2xl:h-[24px] 2xl:w-[24px]';

export const BESTSELLER_VIBE_ARROW_SIDE_CLASS_NAMES = {
  previous: 'left-0',
  next: 'right-0',
} as const;
